var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94666 13.7194C2.75965 13.7191 2.58137 13.6403 2.45533 13.5021C2.32696 13.3651 2.26317 13.1798 2.28 12.9928L2.44333 11.1968L9.98866 3.6541L12.3467 6.01143L4.80333 13.5534L3.00733 13.7168C2.98666 13.7188 2.966 13.7194 2.94666 13.7194ZM12.8173 5.5401L10.46 3.18277L11.874 1.76877C11.999 1.64358 12.1687 1.57324 12.3457 1.57324C12.5226 1.57324 12.6923 1.64358 12.8173 1.76877L14.2313 3.18277C14.3565 3.30781 14.4269 3.47749 14.4269 3.65443C14.4269 3.83137 14.3565 4.00105 14.2313 4.1261L12.818 5.53943L12.8173 5.5401Z",
    fill: "#0098DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.0127ce89361f9c9193b5df4563be367a.svg";
export { ForwardRef as ReactComponent };